// @ts-nocheck
class CartPreorderCheck extends HTMLElement {
  input = null;
  checkoutButtons = [];
  dinamicCheckoutButtons = [];
  constructor() {
    super();

    this.checkoutButtons = document.querySelectorAll('.cart__checkout-button');
    this.dinamicCheckoutButtons = document.querySelectorAll('.cart__dynamic-checkout-buttons');
    this.otherCheckboxes = document.querySelectorAll('[data-cart-preorder-checkbox]');
    this.input = this.querySelector('[data-cart-preorder-checkbox]');
    this.input.addEventListener('change', this.onChange.bind(this));
  }
  onChange(e) {
    if (e.target.checked === true) {
      if (this.checkoutButtons.length > 0) {
        [...this.checkoutButtons].forEach((button) => {
          button.removeAttribute('disabled');
        });
      }
      if (this.dinamicCheckoutButtons.length > 0) {
        [...this.dinamicCheckoutButtons].forEach((button) => {
          button.removeAttribute('disabled');
          button.ariaDisabled = false;
        });
      }
      if (this.otherCheckboxes.length > 0) {
        [...this.otherCheckboxes].forEach((checkbox) => {
          if (checkbox !== e.target) {
            checkbox.checked = true;
          }
        });
      }
    } else {
      if (this.checkoutButtons.length > 0) {
        [...this.checkoutButtons].forEach((button) => {
          button.setAttribute('disabled', '');
        });
      }
      if (this.dinamicCheckoutButtons.length > 0) {
        [...this.dinamicCheckoutButtons].forEach((button) => {
          button.setAttribute('disabled', '');
          button.ariaDisabled = true;
        });
      }
      if (this.otherCheckboxes.length > 0) {
        [...this.otherCheckboxes].forEach((checkbox) => {
          if (checkbox !== e.target) {
            checkbox.checked = false;
          }
        });
      }
    }
  }
}

customElements.define('cart-preorder-check', CartPreorderCheck);
